import { connect } from 'react-redux'
import { State } from '../../redux/reducers/'
import { reset } from 'redux-form'
import { actionCreators } from '../../redux/reducers/ui/uiReducer'
import ModalWrapper from '../../components/modalWrapper/modalWrapperComponent'

export function mapStateToProps (state: State, props) {
  return {
    isOpen: state.ui.showRegistrationModal
  }
}

export const propsMapping = (dispatch, ownProps) => {
  return {
    onRequestClose: () => {
      dispatch(reset('registration'))
      dispatch(actionCreators.toggleRegistrationModal())
    }
  }
}

export default connect(mapStateToProps, propsMapping)(ModalWrapper)



// WEBPACK FOOTER //
// ./src/containers/registerModal/registerModalContainer.js